/* Product page: gallery, option picker, "Which ... for today?", before and after, exploded view, tabs, bag. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var D = {}; try { D = JSON.parse($('#pdpData').textContent); } catch (e) {}
  var B = window.BEEA || {};

  /* gallery */
  var stage = $('#stage'), simg = $('#stageimg'), svid = $('#stagevid'), thumbs = $$('#thumbs [data-k]'), cur = 0;
  /* head glow: the part of the device that lights up, placed over the cutout (pass 4) */
  var heads = [], hEls = [];
  try { heads = JSON.parse((stage && stage.dataset.heads) || '[]'); } catch (e) {}
  heads.forEach(function () {
    var a = document.createElement('span'); a.className = 'hh'; a.setAttribute('aria-hidden', 'true');
    var b = document.createElement('span'); b.className = 'hg' + (stage.dataset.ring ? ' ring' : ''); b.setAttribute('aria-hidden', 'true');
    stage.appendChild(a); stage.appendChild(b); hEls.push([a, b]);
  });
  function placeGlow() {
    if (!hEls.length || !simg || simg.className.indexOf('prod') < 0) return;
    var r = simg.getBoundingClientRect(), s = stage.getBoundingClientRect();
    if (!r.width) return;
    heads.forEach(function (h, i) {
      hEls[i].forEach(function (el) {
        el.style.left = (r.left - s.left + r.width * h[0]) + 'px'; el.style.top = (r.top - s.top + r.height * h[1]) + 'px';
        el.style.width = (r.width * h[2]) + 'px'; el.style.height = (r.height * h[3]) + 'px';
      });
    });
  }
  simg && simg.addEventListener('load', placeGlow);
  window.addEventListener('resize', placeGlow); window.addEventListener('load', placeGlow);
  function show(i) {
    if (!thumbs.length) return;
    cur = (i + thumbs.length) % thumbs.length;
    var t = thumbs[cur], k = t.dataset.k;
    thumbs.forEach(function (x) { x.classList.toggle('on', x === t); });
    $$('#stage .scard,#stage .sover').forEach(function (c) { c.classList.toggle('on', c.dataset.k === k); });
    var card = ['routine', 'reviews', 'stores'].indexOf(k) >= 0;
    stage.classList.toggle('full', k !== 'product' && !/^i\d/.test(k));
    if (k === 'video' && t.dataset.video) {
      simg.style.display = 'none'; svid.style.display = 'block';
      if (svid.getAttribute('src') !== t.dataset.video) { svid.src = t.dataset.video; svid.poster = t.dataset.poster || ''; }
      try { svid.play().catch(function () {}); } catch (e) {}
    } else {
      try { svid.pause(); } catch (e) {}
      svid.style.display = 'none'; simg.style.display = card ? 'none' : 'block';
      if (t.dataset.src) { simg.src = t.dataset.src; simg.className = t.dataset.cls || 'full'; }
    }
    stage.classList.toggle('prodv', k === 'product');
    placeGlow();
    var tag = $('#stagetag'); tag.textContent = t.dataset.tag || ''; tag.style.display = card || !t.dataset.tag ? 'none' : '';
    $('#stagecount').textContent = (cur + 1) + ' / ' + thumbs.length;
  }
  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
  var pv = $('.snav.prev'), nx = $('.snav.next');
  pv && pv.addEventListener('click', function () { show(cur - 1); });
  nx && nx.addEventListener('click', function () { show(cur + 1); });
  var sx = null;
  stage && stage.addEventListener('pointerdown', function (e) { sx = e.clientX; });
  stage && stage.addEventListener('pointerup', function (e) { if (sx === null) return; var dx = e.clientX - sx; sx = null; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); });
  show(0);

  /* option picker and "Which ... for today?" */
  var cols = String(D.colours || '').split(','), tlv = $('#tlv'), light = $('#light');
  function pill(t) { return '<span class="pill">' + String(t).replace(/[<>&]/g, '') + '</span>'; }
  function pick(n) {
    n = String(n);
    $$('#lights button').forEach(function (x) { x.classList.toggle('on', x.dataset.l === n); });
    var b = $('#bAns button[data-l="' + n + '"]');
    $$('#bAns button').forEach(function (x) { x.classList.toggle('on', x === b); });
    var c = String(cols[(+n) - 1] || cols[0]), halo = c.charAt(0) === '~', cp = c.replace('~', '').split('|');
    c = cp[0];
    if (stage) { stage.style.setProperty('--glow', c); stage.style.setProperty('--c', c); stage.style.setProperty('--c2', cp[1] || c); stage.classList.toggle('halo', halo); }
    if (light) light.style.setProperty('--c', c);
    if (tlv && tlv.querySelector('.strip')) tlv.style.setProperty('--i', (+n) - 1);
    if (b) {
      $('#tlName').textContent = b.dataset.name || '';
      $('#tlLine').textContent = b.dataset.line || '';
      $('#tlPills').innerHTML = (b.dataset.pills || '').split(' · ').filter(Boolean).map(pill).join('');
      var cap = $('#tlCap'); if (cap) cap.textContent = (b.dataset.name || '') + ' · ' + (B.t && B.t.community ? B.t.community : 'BEEA community');
    }
  }
  $$('#lights button').forEach(function (b) { b.addEventListener('click', function () {
    /* the device lights up in the chosen colour: bring the product photo back first */
    if (heads.length && thumbs[cur] && thumbs[cur].dataset.k !== 'product') show(0);
    pick(b.dataset.l);
  }); });
  $$('#bAns button').forEach(function (b) { b.addEventListener('click', function () { pick(b.dataset.l); }); });
  if ($('#bAns')) pick(1);

  /* campaign strip: arrows scroll one photo */
  var er = $('#erow');
  $$('.enav [data-e]').forEach(function (b) { b.addEventListener('click', function () {
    var f = er && er.querySelector('figure'); if (!f) return;
    er.scrollBy({ left: (+b.dataset.e) * (f.getBoundingClientRect().width + 14), behavior: 'smooth' });
  }); });

  /* before and after: every slider on the page. Mouse and pen drag with pointer events; a finger drags with touch events:
     a sideways move compares (and blocks the page from scrolling), an up or down move scrolls the page as usual. */
  $$('[data-cmp]').forEach(function (cmp) {
    var r = cmp.querySelector('input[type=range]'), drag = false, sx = 0, sy = 0, mode = 0;
    var cset = function (p) { p = Math.max(0, Math.min(100, p)); cmp.style.setProperty('--p', p + '%'); if (r) r.value = Math.round(p); };
    var cx = function (x) { var b = cmp.getBoundingClientRect(); cset((x - b.left) / b.width * 100); };
    cmp.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') return; drag = true; cmp.setPointerCapture(e.pointerId); cx(e.clientX); });
    cmp.addEventListener('pointermove', function (e) { if (drag && e.pointerType !== 'touch') cx(e.clientX); });
    ['pointerup', 'pointercancel'].forEach(function (t) { cmp.addEventListener(t, function () { drag = false; }); });
    cmp.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; mode = 0; }, { passive: true });
    cmp.addEventListener('touchmove', function (e) {
      var t = e.touches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (!mode) { if (Math.abs(dx) < 4 && Math.abs(dy) < 4) { if (Math.abs(dx) >= Math.abs(dy)) e.preventDefault(); return; } mode = Math.abs(dx) > Math.abs(dy) ? 1 : 2; }
      if (mode === 1) { e.preventDefault(); cx(t.clientX); }
    }, { passive: false });
    cmp.addEventListener('touchend', function (e) { if (!mode && e.changedTouches[0]) cx(e.changedTouches[0].clientX); mode = 0; }, { passive: true });
    if (r) r.addEventListener('input', function () { cset(+r.value); });
  });
  $$('[data-bxrow]').forEach(function (row) {
    var w = row.closest('.bx-wrap'), bs = w ? w.querySelectorAll('[data-bx]') : [], cnt = w && w.querySelector('.bx-cnt');
    var cards = row.querySelectorAll('.bx');
    var upd = function () {
      var max = row.scrollWidth - row.clientWidth;
      if (w) w.classList.toggle('scroll', max > 2);
      if (bs.length) { bs[0].disabled = row.scrollLeft < 4; bs[1].disabled = row.scrollLeft > max - 4; }
      if (cnt && cards.length) {
        var rb = row.getBoundingClientRect(), first = 0, last = 0;
        Array.prototype.forEach.call(cards, function (c, i) { var b = c.getBoundingClientRect(); if (b.left >= rb.left - 8 && b.right <= rb.right + 8) { if (!first) first = i + 1; last = i + 1; } });
        cnt.textContent = first ? (first === last ? first : first + '–' + last) + ' / ' + cards.length : '';
      }
    };
    Array.prototype.forEach.call(bs, function (b) { b.addEventListener('click', function () {
      var g = parseFloat(getComputedStyle(row).columnGap) || 18;
      row.scrollBy({ left: (+b.dataset.bx) * (row.clientWidth + g), behavior: 'smooth' });
    }); });
    row.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  });

  /* exploded view (GLAM) */
  function xpart(n) { $$('.xn').forEach(function (x) { x.classList.toggle('on', x.dataset.x === n); }); $$('.xpart').forEach(function (x) { x.classList.toggle('on', x.dataset.x === n); }); }
  $$('.xn,.xpart').forEach(function (b) { b.addEventListener('click', function () { xpart(b.dataset.x); }); });
  $$('#exVis .xo button').forEach(function (b) { b.addEventListener('click', function () {
    $$('#exVis .xo button').forEach(function (x) { x.classList.toggle('on', x === b); });
    var im = $('#exImg'); im.src = im.dataset[b.dataset.o]; $('#exVis').classList.toggle('b', b.dataset.o === 'b');
  }); });
  if ($('.xn')) xpart('1');

  /* bag: main device, optional add-on, "This is a gift" */
  var gOn = $('#gOn'), gText = $('#gText'), addon = $('#bAddon');
  function label() { var p = D.price + (addon && addon.checked ? +addon.dataset.price : 0); var el = $('#addPrice'); if (el && window.BEEAcart) el.textContent = BEEAcart.money(p); }
  addon && addon.addEventListener('change', label);
  gOn && gOn.addEventListener('change', function () { $('#giftmsg').classList.toggle('on', gOn.checked); if (gOn.checked) gText.focus(); });
  gText && gText.addEventListener('input', function () { $('#gCnt').textContent = gText.value.length; });
  function buy(checkout) {
    if (!window.BEEAcart || !D.variant) return;
    var items = [{ id: D.variant, quantity: 1 }];
    if (addon && addon.checked && B.devices[addon.dataset.addon]) items.push({ id: B.devices[addon.dataset.addon].variant, quantity: 1 });
    var attrs = gOn ? (gOn.checked ? { 'Gift': 'Yes', 'Gift message': gText.value.trim() } : { 'Gift': '', 'Gift message': '' }) : null;
    BEEAcart.add(items, attrs, { checkout: checkout });
  }
  var form = $('#buyform');
  form && form.addEventListener('submit', function (e) { e.preventDefault(); buy(false); });
  ['#miniAdd', '#sbAdd'].forEach(function (s) { var b = $(s); b && b.addEventListener('click', function () { buy(false); }); });
  var bn = $('#buyNow'); bn && bn.addEventListener('click', function () { buy(true); });

  /* sold out: the waitlist replaces the buttons (draft: nothing is sent yet) */
  if (!D.available) document.body.classList.add('soldout');
  var wf = $('#wForm'); wf && wf.addEventListener('submit', function (e) { e.preventDefault();
    var em = ($('#wMail').value || '').trim(); if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) { $('#wMail').focus(); return; }
    try { fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=XnQJQh', { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2025-01-15' },
      body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: em } } } },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + wf.dataset.variant } } } } }) }).catch(function () {});
      var nw = $('#wNews'); if (nw && nw.checked) fetch('https://a.klaviyo.com/client/subscriptions/?company_id=XnQJQh', { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2025-01-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'BEEA waitlist', profile: { data: { type: 'profile', attributes: { email: em } } } }, relationships: { list: { data: { type: 'list', id: 'QU2f7Q' } } } } }) }).catch(function () {});
    } catch (x) {}
    $('#wait').classList.add('sent'); });

  /* section tabs follow the scroll */
  var links = $$('.tabs a[href^="#"]');
  if ('IntersectionObserver' in window && links.length) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) links.forEach(function (l) { l.classList.toggle('on', l.getAttribute('href') === '#' + e.target.id); }); }); }, { rootMargin: '-40% 0px -55% 0px' });
    links.forEach(function (l) { var t = document.querySelector(l.getAttribute('href')); t && io.observe(t); });
  }

  // store card: one retailer at a time (all of them, not only Müller)
  var srot = document.getElementById('srot');
  if (srot) {
    var ss = srot.children, si = 0;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) srot.classList.add('all');
    else if (ss.length > 1) setInterval(function () { ss[si].classList.remove('on'); si = (si + 1) % ss.length; ss[si].classList.add('on'); }, 2200);
  }
})();

/* Product-page videos load and play only when they are on screen (SEO pass 29 Sep: first load was 4 MB on GLAM because 7+ clips autoplayed below the fold) */
(function () {
  var vs = [].slice.call(document.querySelectorAll('video[data-lazyplay]'));
  if (!vs.length) return;
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var go = function (v) { if (still) return; if (v.preload === 'none') v.preload = 'auto'; var p = v.play(); p && p.catch && p.catch(function () {}); };
  if (!('IntersectionObserver' in window)) { vs.forEach(go); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (e) { var v = e.target; if (e.isIntersecting && e.intersectionRatio >= 0.3) go(v); else if (!v.paused) v.pause(); }); }, { threshold: [0, 0.3] });
  vs.forEach(function (v) { io.observe(v); });
})();
